export default function AboutCTA() {
  return (
    <section className="relative overflow-hidden px-5 md:px-8 py-28">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/images/about-cta-01.jpg"
          alt="CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#061e45]/55" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#061e45]/80 via-[#061e45]/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left */}
          <div>
            <p
              className="text-[#d3b366] text-[10px] uppercase tracking-[0.25em] font-medium mb-6"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Work With Us
            </p>
            <h2
              className="text-white text-4xl md:text-5xl lg:text-[54px] font-light leading-[1.1] mb-8"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              See What You've Been
              <br />
              <em className="not-italic text-[#d3b366]">Missing.</em>
            </h2>
            <p
              className="text-white/60 text-[15px] leading-relaxed max-w-lg"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              No pitch decks. No pressure. Just a clear breakdown of what you're paying today—and what needs to change.
            </p>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-8">
            {/* Stat row */}
            <div className="grid grid-cols-3 gap-px bg-white/10">
              {[
                { value: '15–30%', label: 'Avg. Overpayment Recovered' },
                { value: '60 days', label: 'To Full Visibility' },
                { value: '24/7', label: 'Dedicated Support' },
              ].map((s) => (
                <div key={s.label} className="bg-white/5 px-6 py-6 text-center">
                  <p
                    className="text-[#d3b366] text-2xl font-light mb-1"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {s.value}
                  </p>
                  <p
                    className="text-white/40 text-[10px] uppercase tracking-[0.12em] leading-relaxed"
                    style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                  >
                    {s.label}
                  </p>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/contact"
                className="whitespace-nowrap inline-flex items-center justify-center px-8 py-4 bg-[#d3b366] text-[#061e45] text-[12px] uppercase tracking-[0.18em] font-semibold hover:bg-[#a8894a] hover:text-white transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Get Your Free Analysis
              </a>
              <a
                href="/solutions"
                className="whitespace-nowrap inline-flex items-center justify-center gap-3 px-8 py-4 border border-white/30 text-white text-[12px] uppercase tracking-[0.18em] font-medium hover:border-white/70 hover:bg-white/5 transition-all duration-200 cursor-pointer"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Explore Solutions
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
